import type { FaireProductEntity } from "../../entity_types/product";

export const p_rmgbugh8ga: FaireProductEntity = {
  token: "p_rmgbugh8ga",
  type: "product",
  name: "NUEVE LEONES",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl: "https://cdn.faire.com/fastly/5e16d8a3c332b6df675eb1d4c117869bd1096a5d02b2311c2026cd908d26f661.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bb11001140e822e16279ab87fb8696908d759f92c706624aca5d7967a40085e3.jpeg",
    "https://cdn.faire.com/fastly/67e696b6ef48865ed98f5e1e75179bebf8591ce1a4765faa302dd83b143803ca.jpeg",
    "https://cdn.faire.com/fastly/2d542d443e973dab7710576db7afae0902e6c5414688ef5cca44d365cc707253.jpeg"
  ],
  priceDollars: 19,
  description: "Inspired by the rich nightlife of Roma Norte, an explosion of colorful street art and bohemian energy. Chic cafes and bars around every corner brimming with dimly lit moody spaces and eclectic charm. Unleash your inner creative with the sacred scent of burning copal, hinoki wood and tanned leathers.\n\nTanned leather, santal, hinoki woods, copal, horchata\n\nIllustrations by fellow dreamer Freddy Terriquez; when he's not packing candles he's sketching some of our favorite designs.\n\nThese beautiful hand-painted jars are designed to be re-loved and reused.\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn. We use lead-free cotton wicks and premium fragrance oils. All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials.\n\n8 ounces (226g), comes in our signature Mexico City box.",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:05:04.889Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
